module.exports = __webpack_public_path__ + "static/img/vip5.eb790e01.png";